<template>

  <div class="columns is-centered is-vcentered">

    <div class="column is-three-fifths-desktop is-four-fifths-tablet">

      <div class="card" style="padding: 30px 30px; margin-top: 35px;" :style="{opacity: (submitInProgress ? 0.3 : 1)}">
        <div class="card-content">

        <b-field label="Player's name" style="text-align: left;">
          <b-input v-model="name1" v-focus placeholder="Player's name" required></b-input>
        </b-field>

          <b-field label="Player's team" style="text-align: left;">
            <b-select v-model="team1" placeholder="Select..." expanded required>
              <option :value="team.id" v-for="team in teams">{{team.name}}</option>
            </b-select>
          </b-field>

          <b-field label="Partner's name" style="text-align: left; margin-top: 50px;" v-if="eventType == 'doubles'">
            <b-input v-model="name2" placeholder="Partner's name" required></b-input>
          </b-field>

          <b-field label="Partner's team" style="text-align: left;" v-if="eventType == 'doubles'">
            <b-select v-model="team2" placeholder="Select..." expanded required>
              <option :value="team.id" v-for="team in teams">{{team.name}}</option>
            </b-select>
          </b-field>

          <b-field label="Event" style="text-align: left;" v-if="moveToEvent !== undefined && tournament && tournament.events.length > 0">
            <b-select v-model="moveToEvent" placeholder="Select..." expanded>
              <option :value="event.id" v-for="event in tournament.events">{{event.name}}</option>
            </b-select>
          </b-field>

          <div style="margin-top: 30px; width: 85%; max-width: 300px; margin-left: 9%; margin-left: auto;">
          <b-field label="Status" style="text-align: left;" v-if="id">
            <b-select v-model="missing" placeholder="Select..." expanded required>
              <option value="false">Present at event</option>
              <option value="true">Missing or injured</option>
            </b-select>
          </b-field>
          </div>



          <p v-if="failedSubmit" style="margin-top: 27px; text-align: left; color: red;">Please make sure you complete all fields.</p>


        <div style="text-align: right;">
          <button class="button is-danger" v-if="id" style="margin-top: 25px; margin-bottom: -10px; margin-right: 30px;" @click.ctrl="moveToEvent = tournament.events[0].id" @click.exact="deleteEntry">Delete</button>
          <button class="button is-primary" style="margin-top: 25px; margin-bottom: -10px;" @click="triggerSubmit">Submit changes</button>
        </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import axios from '../request';
import TournamentDataMixin from '../mixins/TournamentDataMixin.js';

export default {
  mixins: [ TournamentDataMixin ],

  data: function() {
    return {
      name1: '',
      name2: '',

      team1: null,
      team2: null,

      missing: false,
      submitInProgress: false,
      failedSubmit: false,

      moveToEvent: undefined
    }
  },

  computed: {
    eventType: function() {
      if (this.event && this.event.type === 'doubles') {
        return 'doubles';
      }

      return 'singles';
    },

    teams: function() {
      if (this.tournament) {
        return this.tournament.teams;
      }

      return [];
    },

    event: function() {
      let selected = null;
      if (this.tournament && this.tournament.events) {
        selected = this.tournament.events.filter(event => event.id == this.eventId);
        if (selected && selected.length > 0) {
          selected = selected[0];
        } else {
          selected = null;
        }
      }

      return selected;
    },
    eventId: function() { return this.$route.params.event; },
    id: function() { return this.$route.params.entry; },
  },

  watch: {
    tournament: {
      immediate: true,

      handler() {
        if (this.tournament && this.event && this.id) {
          let entry = this.event.entries.filter(entry => entry.id == this.id);
          if (entry && entry.length > 0) {
            this.name1 = entry[0].name1;
            this.team1 = entry[0].team1;

            if (this.event.type === 'doubles') {
              this.name2 = entry[0].name2;
              this.team2 = entry[0].team2;
            }

            if (entry[0].missing) {
              this.missing = true;
            }
          }
        }
      }
    }
  },

  methods: {
    deleteEntry: function() {
      let entry = this.event.entries.filter(entry => entry.id == this.id)[0];

      this.$dialog.confirm({
        message: 'Are you sure you want to delete this entry?\nThis action will only succeed if the entry doesn\'t appear in any draws.',
        type: 'is-danger',
        onConfirm: () => { this.$store.dispatch('deleteItem', { type: 'entry', item: entry }); }
      });
    },

    triggerSubmit: function() {

      if (this.submitInProgress) {
        return /* don't do multiple requests */;
      }

      let vm = this;
      vm.submitInProgress = true;
      vm.failedSubmit = false;

      let tournamentId = this.$route.params.id;
      let eventId = this.moveToEvent ? this.moveToEvent : this.$route.params.event;

      let suggestedPage = '/tournaments/' + tournamentId + '/events/' + (this.$route.params.event) + '/entries';
      if (this && this.$route.query && this.$route.query.next) {
        suggestedPage = this.$route.query.next;
      }

      let entryToDelete = undefined;
      if (this.moveToEvent) {
        entryToDelete = this.event.entries.filter(entry => entry.id == this.id)[0];
      }

      axios.post('/api/tournament/' + tournamentId + '/event/' + eventId + '/entries', {
        name1: this.name1,
        team1: this.team1,
        name2: this.name2,
        team2: this.team2,

        missing: this.missing,
        id: (this.moveToEvent ? null : this.id)
      })

              .then(function(response){
                vm.submitInProgress = false;
                vm.failedSubmit = false;

                if (entryToDelete) {
                  vm.$dialog.confirm({
                    message: 'Are you sure you want to move and delete this entry?',
                    type: 'is-danger',
                    onConfirm: () => {
                      vm.$store.dispatch('deleteItem', { type: 'entry', item: entryToDelete });
                    }
                  });
                }

                vm.$store.dispatch('tournamentEventsChanged', { tournamentId: tournamentId, events: response.data, suggestedPage: suggestedPage, stayOnPage: (entryToDelete != undefined) });
              })
              .catch(function(){
                vm.submitInProgress = false;
                vm.failedSubmit = true;
              });

    }
  },

  name: 'edit-tournament-event-entries'
}
</script>



<style scoped>

</style>